import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography } from "@mui/material";

const AnyModal = ({ open, onClose, headTitle, ComponentComp, data, fetch }) => {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                    <IconButton sx={{ color: "red", width: '2.5rem' }} onClick={onClose}>x</IconButton>
                </Box>
                <Typography style={{ textAlign: "center", fontSize:"2rem", fontWeight:"bold" }}>{headTitle}</Typography>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "auto" }}>
                    <ComponentComp data={data} fetch={fetch} onClose={onClose} />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default AnyModal;
